import { render, staticRenderFns } from "./CardPopup.vue?vue&type=template&id=29876c3b"
import script from "./CardPopup.vue?vue&type=script&lang=js"
export * from "./CardPopup.vue?vue&type=script&lang=js"
import style0 from "./CardPopup.vue?vue&type=style&index=0&id=29876c3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports